/**
 * Send one GA4 event. No-ops when gtag is absent — the page is server-rendered
 * for crawlers, blocked by extensions for a meaningful share of this audience,
 * and analytics must never be the reason a flow throws.
 *
 * @param {string} name GA4 event name.
 * @param {object} [params] GA4 event params.
 * @returns {void}
 */
export function trackEvent(name, params = {}) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
}

/**
 * Attach user-scoped properties to this GA4 client.
 *
 * Event params (what `trackEvent` sends) are event-scoped: GA4 can break an
 * event down by them, but it cannot cross them with session- or user-scoped
 * dimensions like `newVsReturning`. A user property is stamped on the *user*,
 * so it survives across sessions and can be crossed with anything — which is
 * the only way to ask "did this arm's visitors come back?".
 *
 * Must also be registered in GA4 Admin → Custom definitions as a **user-scoped**
 * custom dimension, and registration is not retroactive.
 *
 * @param {object} props Property name → value.
 * @returns {void}
 */
export function setUserProperties(props) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('set', 'user_properties', props);
}
